module.exports = __webpack_public_path__ + "img/avatar_4.aef97506.svg";